import script from "./AppNav.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNav.vue?vue&type=script&setup=true&lang=js"

import "./AppNav.vue?vue&type=style&index=0&id=6671b422&lang=scss"

const __exports__ = script;

export default __exports__